































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class StatusPsikologi extends Vue {
  @Ref() lainnya!: HTMLInputElement;
  @Prop() psikologiText: string;
  @Prop() psikologiId: string;

  @Watch("psikologiId")
  schanged(v) {
    this.$emit("stsPsikologiId", v);
    this.psikologiId = v;
    if (v === "9") {
      this.lainnya.focus();
    } else {
      this.psikologiText = "";
      this.$emit("stsPsikologiText", this.psikologiText);
    }
  }
  @Watch("psikologiText")
  kchanged(v) {
    this.$emit("stsPsikologiText", v);
    this.psikologiText = v;
  }
}
